import heading from 'text!./templates/Heading.html';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: heading,
        scope: {}
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/titles/Heading.js
// module id = 1175
// module chunks = 0